import { IAuthAdapter } from './IAuthAdapter';
import { ApiResponse } from '../../types/api';
import {
  AuthSession,
  LoginCredentials,
  RegisterDto,
  ForgotPasswordDto,
  ResetPasswordDto,
  ChangePasswordDto,
} from '../../types/auth';
import { ApiClient } from '../apiClient';

export class LaravelAuthAdapter implements IAuthAdapter {
  async login(credentials: LoginCredentials): Promise<ApiResponse<AuthSession>> {
    return ApiClient.post<AuthSession>('/api/v1/auth/login', credentials);
  }

  async register(dto: RegisterDto): Promise<ApiResponse<AuthSession>> {
    return ApiClient.post<AuthSession>('/api/v1/auth/register', dto);
  }

  async logout(): Promise<ApiResponse<void>> {
    return ApiClient.post<void>('/api/v1/auth/logout', {});
  }

  async getCurrentUser(token: string): Promise<ApiResponse<AuthSession>> {
    return ApiClient.get<AuthSession>('/api/v1/auth/me');
  }

  async forgotPassword(dto: ForgotPasswordDto): Promise<ApiResponse<void>> {
    return ApiClient.post<void>('/api/v1/auth/forgot-password', dto);
  }

  async resetPassword(dto: ResetPasswordDto): Promise<ApiResponse<void>> {
    return ApiClient.post<void>('/api/v1/auth/reset-password', dto);
  }

  async changePassword(dto: ChangePasswordDto): Promise<ApiResponse<void>> {
    return ApiClient.post<void>('/api/v1/auth/change-password', dto);
  }
}
